import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CertificationReportForm from '../../../../../shared/Cis/CertificationReports/Form/CertificationReportForm';
import { loadMaCisDetailsCreator, updateMaCisCreator } from '../../../../../store/actionsCreators';
import reducer, { defaultState, setInitialStateCreator, updateFieldCreator } from './reducer';

const MaCertificationReportForm = ({
  appType,
  type,
  reports,
  loadReportDetails,
  id,
  updateReport,
  userPermissions,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <CertificationReportForm
      appType={appType}
      type={type}
      reports={reports}
      loadReportDetails={loadReportDetails}
      updateReport={updateReport}
      id={id}
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      setInitialStateCreator={setInitialStateCreator}
      userPermissions={userPermissions}
    />
  );
};

MaCertificationReportForm.propTypes = {
  appType: PropTypes.string.isRequired,
  certificationBody: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    initials: PropTypes.string,
    sameAsMaContactData: PropTypes.bool,
    country: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    cbHeadName: PropTypes.string,
    cbHeadEmail: PropTypes.string,
    cbHeadTelephone: PropTypes.string,
    address: PropTypes.shape({
      id: PropTypes.number,
    }),
    lcAgreementSignedAt: PropTypes.string,
    lcValidationSignedAt: PropTypes.string,
    deltaAgreementSignedAt: PropTypes.string,
    iso9001AccreditationSignedAt: PropTypes.string,
    iso17024AccreditationSignedAt: PropTypes.string,
    cctAgreementSignedAt: PropTypes.string,
    memberAssociation: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      initials: PropTypes.string,
      photo: PropTypes.string,
    }),
    levels: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        domains: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
          }),
        ),
      }),
    ),
  }),
  status: PropTypes.string,
  type: PropTypes.string,
  updateReport: PropTypes.func.isRequired,
  loadReportDetails: PropTypes.func.isRequired,
  id: PropTypes.number,
};

MaCertificationReportForm.defaultProps = {
  reports: {},
  type: 'ma',
  id: 0,
};

const mapStateToProps = ({ user, ma }) => ({
  appType: user.appType,
  reports: ma.cis.reports.details,
  id: ma.cis.reports.profile?.id ?? 0,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  updateReport: (id, payload, history) =>
    dispatch(updateMaCisCreator(id, 'reports', payload, history)),
  loadReportDetails: (payload, history) =>
    dispatch(loadMaCisDetailsCreator('reports', payload, history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaCertificationReportForm);
